namespace $.$$ {

	export class $shm_hitalama_map_widget_float_notebook2_adds extends $.$shm_hitalama_map_widget_float_notebook2_adds {

		add_lines() {
			const notebook = this.Notebook() as $shm_hitalama_map_widget_float_notebook2
			return Array.from(
				{ length: notebook.links().length + 1 },
				( _, pos ) => this.Add_line( this.line_id( notebook.widget().link_str(), pos ) ),
			)
		}

		notebook( link: string ) {
			return this.Map_page().Widget( new $giper_baza_link( link ) ).Sub() as $shm_hitalama_map_widget_float_notebook2
		}

		line_id( link: string, pos: number ) {
			return link + '|' + pos
		}

		line_parts( id: string ) {
			const index = id.lastIndexOf( '|' )
			return {
				link: id.slice( 0, index ),
				pos: Number( id.slice( index + 1 ) ),
			}
		}

		add_line_left( id: string ) {
			const { link } = this.line_parts( id )
			const notebook = this.notebook( link )
			return notebook.left() + notebook.width() / 2
		}

		add_line_left_px( id: string ) {
			return this.add_line_left( id ) + 'px'
		}

		add_line_top( id: string ) {
			const { link, pos } = this.line_parts( id )
			const notebook = this.notebook( link )
			const links = notebook.links()
			let top = notebook.top() + notebook.padding_top()

			for( let i = 0; i < pos && i < links.length; i++ ) {
				const widget = this.Map_page().Widget( new $giper_baza_link( links[i] ) ).Sub()
				top += widget.height() + notebook.gap()
			}

			return top
		}

		add_line_top_px( id: string ) {
			return this.add_line_top( id ) + 'px'
		}

		add_line_real_pos( id: string ): readonly [ number, number ] {
			return [
				this.add_line_left( id ),
				this.add_line_top( id ),
			]
		}

		add_line_showed( id: string ) {
			if( this.Add_line( id ).hovered() ) return true

			const { link, pos } = this.line_parts( id )
			const hovered = this.hovered_inner_pos( link )
			return pos == hovered || pos == hovered + 1
		}

		hovered_inner_pos( link: string ) {
			return this.notebook( link ).links().findIndex( inner => {
				return this.Map_page().Widget( new $giper_baza_link( inner ) ).Sub().hovered()
			} )
		}

		add_widget( id: string, type: string ) {
			if( this.add_types().length > 0 && !this.add_types().includes( type ) ) return null

			this.Add_line( id ).focused( false )
			const { link, pos } = this.line_parts( id )
			const presets = $shm_hitalama_map_widget_presets.for_map( this.Map_page().map() )
			const w = ( presets as any )[ type ]( this.add_line_real_pos( id ) ) as $shm_hitalama_map_widget
			const widget = this.Map_page().Widget( w.link() ) as $shm_hitalama_map_widget_any
			const widget_view = widget.Sub()
			this.warm_widget_view( widget_view )
			this.notebook( link ).insert_widget( pos, w )
			new $mol_after_frame( ()=> widget_view.selected( true ) )
			return w
		}

		//todo //fix me
		warm_widget_view( widget: $shm_hitalama_map_widget_any_widget ) {
			widget.top()
			widget.left()
			widget.width()
			widget.height()
		}

		Add_line( id: string ): $.$shm_hitalama_map_widget_float_notebook2_adds_line {
			const obj = super.Add_line( id )
			obj.widget_add = ( type )=> {
				this.add_widget( id, type )
			}
			return obj
		}

	}

}
